import { Route, Routes } from 'react-router-dom';
import './App.css';
import { QuestRoute } from './components/QuestRoute';
import { PhotoboothRoute } from './components/PhotoboothRoute';
import { Layout } from './Layout';
import { HomePage } from './pages/HomePage';
import { QuestPage } from './pages/QuestPage';
import { QUEST_PAGES } from './questPages';

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/photos" element={<PhotoboothRoute />} />
        {QUEST_PAGES.map((page) => (
          <Route
            key={page.id}
            path={page.path.replace(/^\//, '')}
            element={
              <QuestRoute>
                <QuestPage />
              </QuestRoute>
            }
          />
        ))}
      </Route>
    </Routes>
  );
}
